export default __webpack_public_path__ + "static/media/icon-quien-soy.91a74892.svg";